import {Link, createFileRoute} from '@tanstack/react-router';

import {Button} from '@/components/ui/button';

// Splat under `_authenticated` so the layout's `beforeLoad` permission guard
// fires for any URL that doesn't match a more specific child route. Without
// this, paths like `/admin` for an external user fall through to TanStack's
// default top-level not-found, which renders outside the authenticated layout
// and skips the guard entirely — meaning no redirect to `home_page`, plus a
// runtime warning about the missing notFoundComponent.
export const Route = createFileRoute('/_authenticated/$')({
  component: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-16 text-center">
      <h1 className="text-3xl font-bold">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you&apos;re looking for doesn&apos;t exist or has moved.
      </p>
      <Button asChild>
        <Link to="/">Return home</Link>
      </Button>
    </div>
  );
}
